import { extend } from 'vee-validate'
import { max } from 'vee-validate/dist/rules'

// Max rule
extend('max', {
  ...max,
  message: 'Pole może zawierać maksymalnie {length} znaków'
})
